import script from "./ExternalUsersModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ExternalUsersModal.vue?vue&type=script&setup=true&lang=js"

import "./ExternalUsersModal.vue?vue&type=style&index=0&id=3d0d8458&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d0d8458"]])

export default __exports__